import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  close() {
    // Remove the turbo-frame containing the modal
    this.element.closest("turbo-frame").remove();
  }
}
